import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";
import React from "react";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div>Loading...</div>;
  
  if (!user) {
    // Store the full intended destination (path + query + hash) in sessionStorage as a fallback
    const fullPath = `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;
    // Only store if we have a valid path
    if (fullPath && fullPath !== '') {
      sessionStorage.setItem('returnTo', fullPath);
    }
    // Also pass it via state for immediate access
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
